var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 181 c0 -14 -10 -20 -41 -24 -51 -7 -68 -22 -76 -70 -6 -39 5 -48 27 -22 7 9 29 15 51 15 32 0 39 -3 39 -20 0 -29 11 -25 55 20 l39 40 -39 40 c-43 44 -55 49 -55 21z m55 -91 c-28 -29 -30 -30 -37 -10 -5 15 -16 20 -43 20 -20 0 -45 -5 -56 -10 -16 -9 -19 -7 -19 8 0 29 21 42 68 42 36 0 45 4 49 21 6 20 7 19 36 -10 l31 -31 -29 -30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokShareIcon);
export default __webpack_public_path__ + "static/media/tiktok-share-icon.b84a043bd45fd58cec834ddfcc8ca8ac.svg";
export { ForwardRef as ReactComponent };